<template>
    <div class="content_box mobile_content">
        <div class="content product-category-setting">
            <div class="tip">注：如需新增产品分类，可在知识库管理页面添加</div>
            <el-table
                :data="listData"
                highlight-current-row
                style="width: 100%">
                <el-table-column prop="product_name" label="产品分类" show-overflow-tooltip min-width="100"></el-table-column>
                <el-table-column label="产品型号" show-overflow-tooltip min-width="150">
                    <template slot-scope="scope">
                        <span>{{scope.row.productTypes.length > 0 ? scope.row.productTypes.join('；') : '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="问题责任方" show-overflow-tooltip min-width="150">
                    <template slot-scope="scope">
                        <span>{{scope.row.problemSource.length > 0 ? scope.row.problemSource.join('；') : '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="50">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="update(scope.row)" v-if="roleCheck('101-103-101-102')">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <Gh-Dialog ref="dislog" size="big" title="编辑产品分类" @dialogBack="confirm">
                <template v-slot:content>
                    <el-form label-width="100px" @submit.native.prevent>
                        <el-form-item label="产品分类:">
                            <span>{{productName}}</span>
                        </el-form-item>
                        <el-form-item label="产品型号:">
                            <el-tag
                                :key="tag"
                                v-for="tag in updateData.productTypes"
                                closable
                                :disable-transitions="false"
                                @close="handleClose(tag,'productTypes')">
                                {{tag}}
                            </el-tag>
                            <el-input
                                class="input-new-tag"
                                v-if="inputTypeVisible"
                                v-model="inputValue"
                                maxlength="10"
                                ref="saveTypeInput"
                                size="small"
                                @keyup.enter.native="handleInputConfirm('productTypes')"
                                @blur="handleInputConfirm('productTypes')"
                            >
                            </el-input>
                            <el-button v-else class="button-new-tag" size="small" @click="showTypeInput(1)">+</el-button>
                        </el-form-item>
                        <el-form-item label="问题责任方:">
                            <el-tag
                                :key="tag"
                                v-for="tag in updateData.problemSource"
                                closable
                                :disable-transitions="false"
                                @close="handleClose(tag, 'problemSource')">
                                {{tag}}
                            </el-tag>
                            <el-input
                                class="input-new-tag"
                                v-if="inputSourceVisible"
                                v-model="inputValue"
                                maxlength="10"
                                ref="saveSourceInput"
                                size="small"
                                @keyup.enter.native="handleInputConfirm('problemSource')"
                                @blur="handleInputConfirm('problemSource')"
                            >
                            </el-input>
                            <el-button v-else class="button-new-tag" size="small" @click="showTypeInput(2)">+</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'product-category-setting',
    data() {
        return {
            listData: [],
            updateData: {},
            productName: '',
            inputTypeVisible: false,
            inputValue: '',
            inputSourceVisible: false
        }
    },
    created() {
        this.getProductCate();
    },
    methods: {
        getProductCate() {
            this.api.getProductCate({}).then(data => {
                this.listData = data.data.productCateInfos;
            })
        },
        update(item) {
            this.productName = item.product_name;
            this.updateData = {
                product_id: item.product_id,
                productTypes: [...item.productTypes],
                problemSource: [...item.problemSource]
            };
            this.$refs.dislog.show = true;
        },
        showTypeInput(type) {
            this.inputValue = '';
            if(type == 1) {
                this.inputTypeVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTypeInput.$refs.input.focus();
                });
            }else{
                this.inputSourceVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveSourceInput.$refs.input.focus();
                });
            }
            
        },
        handleInputConfirm(type) {
            if(this.inputValue) {
                if(this.updateData[type].indexOf(this.inputValue) == -1) {
                    this.updateData[type].push(this.inputValue);
                }
            }
            this.inputTypeVisible = false;
            this.inputSourceVisible = false;
            this.inputValue = '';
        },
        handleClose(tag, type) {
            this.updateData[type].splice(this.updateData[type].indexOf(tag), 1);
        },
        confirm() {
            this.api.updateProductCate(this.updateData).then(data => {
                this.getProductCate();
                this.$refs.dislog.show = false;
                this.$message.success('修改成功!');
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .tip{
        font-size: 14px;
        color: @colorBlue2;
    }
    .el-tag{
        height: auto;
        line-height: 1.7;
        padding: 5px 10px;
        white-space: inherit;
        margin-right: 10px;
        margin-bottom: 10px;
    }
    .el-form{
        .input-new-tag{
            width: 150px;
            /deep/.el-input__inner{
                min-width: 150px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/order/order-settings/product-category-setting.vue